import { render, staticRenderFns } from "./snippets.vue?vue&type=template&id=485029f7&scoped=true&"
import script from "./snippets.vue?vue&type=script&lang=js&"
export * from "./snippets.vue?vue&type=script&lang=js&"
import style0 from "./snippets.vue?vue&type=style&index=0&id=485029f7&prod&scoped=true&lang=css&"
import style1 from "./snippets.vue?vue&type=style&index=1&id=485029f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485029f7",
  null
  
)

export default component.exports